// Derives an env suffix from a hostname/domain string.
// Works in both server (pass CURRENT_ACTIVE_DOMAIN) and client (pass window.location.hostname) contexts.
// Kept in a plain utility file so it can be imported by client components without pulling in @remix-run/node.
export const getEnvSuffix = (domain?: string): string => {
  const d = domain || ''
  if (d.includes('develop')) return '_dev'
  if (d.includes('qa')) return '_qa'
  if (d.includes('uat')) return '_uat'
  if (d.includes('mpowerfinancing.com')) return '_prod'
  return '_dev'
}
